import {
  Routes,
  Route,
} from 'react-router-dom'

import ProtectedRoutes from './components/ProtectedRoutes';
import Home from './pages/home/Home';


//Finances
import Finances from './pages/finances/Finances'
import Payouts from 'pages/finances/subpages/Payouts/Payouts';
import Transactions from 'pages/finances/subpages/Transactions/Transactions';

//Users
import Users from 'pages/users/Users';
import User from 'pages/users/UserById/User';
import Deposits from 'pages/finances/subpages/Deposits/Deposits';
import TransactionById from 'pages/finances/subpages/Transactions/TransactionById/TransactionById';



function App() {

  return (
    <div className="App">
      <Routes>
        {/* Utils */}
        <Route exact path='/' element={<ProtectedRoutes role={[1, 2, 3]}><Home /></ProtectedRoutes>} />

        {/* Finances */}
        <Route exact path='/finances' element={<ProtectedRoutes role={[1, 2, 3]}><Finances /></ProtectedRoutes>} />
        <Route exact path='/finances/payouts' element={<ProtectedRoutes role={[1, 2, 3]}><Payouts /></ProtectedRoutes>} />
        <Route exact path='/finances/deposits' element={<ProtectedRoutes role={[1, 2, 3]}><Deposits /></ProtectedRoutes>} />
        <Route exact path='/finances/transactions/:id' element={<ProtectedRoutes role={[1, 2, 3]}><TransactionById /></ProtectedRoutes>} />
        <Route exact path='/finances/transactions' element={<ProtectedRoutes role={[1, 2, 3]}><Transactions /></ProtectedRoutes>} />

        {/* Users */}
        <Route exact path='/users' element={<ProtectedRoutes role={[1, 2, 3]}><Users /></ProtectedRoutes>} />
        <Route exact path='/user/:id' element={<ProtectedRoutes role={[1, 2, 3]}><User /></ProtectedRoutes>} />

      </Routes>
    </div>
  );
}

export default App;
